import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import openSocket, { reconnectSocket } from '../services/socket-io';

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [connected, setConnected] = useState(false);

    const setupSocketListeners = useCallback((newSocket) => {
        if (!newSocket) return;

        newSocket.on('connect', () => {
            console.log('Socket conectado globalmente');
            setConnected(true);
        });

        newSocket.on('disconnect', () => {
            console.log('Socket desconectado globalmente');
            setConnected(false);
        });

        setSocket(newSocket);
    }, []);

    useEffect(() => {
        const newSocket = openSocket();
        setupSocketListeners(newSocket);

        return () => {
            if (newSocket) {
                newSocket.off('connect');
                newSocket.off('disconnect');
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const connectSocket = useCallback(() => {
        const newSocket = reconnectSocket();
        setupSocketListeners(newSocket);
    }, [setupSocketListeners]);

    return (
        <SocketContext.Provider value={{ socket, connected, connectSocket }}>
            {children}
        </SocketContext.Provider>
    );
};

export const useSocket = () => {
    const context = useContext(SocketContext);
    if (!context) {
        throw new Error('useSocket deve ser usado dentro de um SocketProvider');
    }
    return context;
};
